export default __webpack_public_path__ + "static/icon-16-4-7db994e5520c43ef7cb047697b056bc6.png";